const $contactForm = $(".js-blind-contact-form form");

$(function () {
  if (
    window.location.pathname.includes("/products/") &&
    window.location.search.includes("contact_posted=true")
  ) {
    $("#blind-quote-modal").show();
    $("body").css("overflow", "hidden");
  }
});

$("#blind-quote").on("click", function (e) {
  e.preventDefault();

  $("#blind-quote-modal").show();
  $("body").css("overflow", "hidden");
});

$(".js-quote-dropdown-trigger").on("click", function () {
  $(this).find("span").toggleClass("blind-quote__dropdown-trigger--active");
  $(".blind-quote__fabric-dropdown").show();
  if ($(this).find("span").hasClass("blind-quote__dropdown-trigger--active")) {
    return;
  }
  $(".blind-quote__fabric-dropdown").hide();
});

$(".js-quote-fabric").on("click", function () {
  $("#blind-fabric-input").val($(this).attr("id"));
  $(".js-quote-fabric").removeClass("blind-quote__fabric-entry--active");

  $(this).addClass("blind-quote__fabric-entry--active");

  $(".blind-quote__fabric-dropdown").hide();
});

$(document).on("mouseup", function (e) {
  let container = $(".blind-quote__fabric-dropdown");

  if (!container.is(e.target) && container.has(e.target).length === 0) {
    container.hide();

    $(".blind-quote__dropdown-trigger").removeClass(
      "blind-quote__dropdown-trigger--active"
    );
  }
});

$("#blind-quote-modal-close").on("click", function () {
  $("#blind-quote-modal").hide();
  $("body").css("overflow", "auto");
});

$(".blind-quote__tooltip").on("mouseover", function () {
  $(this).addClass("blind-quote__tooltip--active");
  $(this).next().addClass("blind-quote__tooltip-item--active");
});

$(".blind-quote__tooltip").on("mouseout", function () {
  $(this).removeClass("blind-quote__tooltip--active");
  $(this).next().removeClass("blind-quote__tooltip-item--active");
});

$(".blind-quote__tooltip").on("click", function () {
  $(this).toggleClass("blind-quote__tooltip--active");
  $(this).next().addClass("blind-quote__tooltip-item--active");
});

$contactForm.on("submit", function (e) {
  const errors = [];
  let $form = $(this);
  let $requiredField = $form.find(".field-required"); //
  let preventSubmit = false;
  let $email = $("#contact-email");
  let emailVal = $email.val();
  let $emailConfirm = $("#contact-email-confirm");
  let emailRegex =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

  // check if all fields are filled in
  $requiredField.each(function () {
    const $field = $(this);

    if ($field.attr("type") === "checkbox") {
      if ($field.get(0).checked === false) {
        preventSubmit = true;
        $field.addClass("checkbox-error");
      } else {
        $field.removeClass("checkbox-error");
      }
    } else {
      const fieldVal = $field.val();
      if (fieldVal === "") {
        preventSubmit = true;
        $field.addClass("is-empty");
      } else {
        $field.removeClass("is-empty");
      }
    }
  });

  if (emailVal !== $emailConfirm.val()) {
    errors.push("Emails must match");
    preventSubmit = true;
    e.preventDefault();
  }

  // if the email is not valid
  if (!emailRegex.test(emailVal)) {
    $email.addClass("is-empty");
    preventSubmit = true;
  }

  // prevent from submitting if klaviyo is not submitted or there is empty value
  if (preventSubmit || $form.hasClass("prevent-submit")) {
    e.preventDefault();
  }

  // trigger submit to klaviyo
  if (!preventSubmit && $form.hasClass("prevent-submit")) {
    submitForm();
  }
});

$contactForm
  .find('input.field-required:not(input[type="checkbox"])')
  .on("keyup", function () {
    if ($(this).val() !== "") {
      $(this).removeClass("is-empty");
    } else {
      $(this).addClass("is-empty");
    }
  });

function submitForm() {
  $(".js-blind-contact-form form").removeClass("prevent-submit");
  $(".js-blind-contact-form form").trigger("submit");
}
